import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IParavetStaffListResponse } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import { useCallback } from "react";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export const useConfigurationParavetStaffListAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      const response = await axios.get<IParavetStaffListResponse>(CONFIGURATION_APIS.PARAVET_STAFF_LIST.baseURL, {
        headers: {
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      return response.data?.data ?? [];
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        captureError(axiosError);
        if (axiosError.config) {
          sendCurl(axiosError.config["curlCommand"]);
        }
      }

      return [];
    }
  }, [configuration]);

  return { execute };
};
